import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import { getAgentMessageById } from './getAgentMessageById';
import type { ChatStoreAction } from './types';

type UpdateActionDataArgs = {
	conversationId: string;
	messageId: string;
	invocationId: string;
	data: unknown;
};

export const updateActionData: SafeAction<[UpdateActionDataArgs]> = createSafeAction(
	StoreActionLoggableName.updateActionData,
	({ conversationId, messageId, invocationId, data }: UpdateActionDataArgs): ChatStoreAction =>
		async ({ getState }, { getMessages, setMessages }) => {
			const currentConversation = getState().conversations[conversationId];
			if (!currentConversation) {
				return;
			}

			const messages = getMessages(conversationId);
			const agentMessage = getAgentMessageById(messages, messageId);

			if (!agentMessage.result) {
				return;
			}

			const updatedMessages = [...messages];

			agentMessage.result.content.message.message.actions?.forEach((action) => {
				if (action.invocationId === invocationId) {
					action.data = {
						...(action.data as Record<string, unknown>),
						...(data as Record<string, unknown>),
					};
				}
			});

			updatedMessages[agentMessage.index] = agentMessage.result;

			setMessages(conversationId, updatedMessages);
		},
);
